export default function rgbaToHex(rgba: string): string {
  try {
    let parts = rgba.substring(rgba.indexOf('(')).split(',');
    const r = parseInt(trim(parts[0].substring(1)), 10);
    const g = parseInt(trim(parts[1]), 10);
    const b = parseInt(trim(parts[2]), 10);
    const a = Number(parseFloat(trim(parts[3].substring(0, parts[3].length - 1))).toFixed(2));

    const color = '#' + r.toString(16) + g.toString(16) + b.toString(16) + (a * 255).toString(16).substring(0, 2);

    return color;
  } catch (err) {
    return '#FFFFFF';
  }
}

export function trim(str: string) {
  return str.replace(/^\s+|\s+$/gm, '');
}

export function hexToRgba(hex: string, alpha: number): string {
  let r = parseInt(hex.slice(1, 3), 16),
    g = parseInt(hex.slice(3, 5), 16),
    b = parseInt(hex.slice(5, 7), 16);

  if (alpha) {
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  return `rgb(${r}, ${g}, ${b})`;
}
